import React from 'react'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'

// What actually happened, per decision.
//
// The statuses are the runners' console lines, one for one, so the old
// instruction to read every REJECT and SKIP survives the move to a web page —
// which is why the rejected and skipped rows are listed first and the applied
// ones are collapsed to a count.
const variantFor = (status) => {
  if (status.startsWith('REJECTED')) return 'danger'
  if (status.startsWith('SKIPPED')) return 'warning'
  return 'success'
}

export default function ApplyReport({ report, onDismiss, onRevert }) {
  if (!report) return null

  if (report.failed) {
    return (
      <Alert variant="danger" onClose={onDismiss} dismissible>
        <Alert.Heading>The request failed</Alert.Heading>
        <p className="mb-0">{String(report.error)}</p>
      </Alert>
    )
  }

  const needsReading = report.outcomes.filter((o) => o.status !== 'APPLIED')

  return (
    <Alert variant={report.dryRun ? 'secondary' : 'success'} onClose={onDismiss} dismissible>
      <Alert.Heading>
        {report.dryRun ? 'Dry run — nothing was written' : 'Applied'}
      </Alert.Heading>
      <p>
        {report.applied} applied, {report.skipped} skipped, {report.rejected} rejected.
      </p>

      {needsReading.length > 0 && (
        <Table size="sm" responsive className="curation-report-table">
          <thead>
            <tr>
              <th>Id</th>
              <th>Status</th>
              <th>Why</th>
            </tr>
          </thead>
          <tbody>
            {needsReading.map((outcome, index) => (
              <tr key={`${outcome.entityId}-${index}`}>
                <td>{outcome.groupKey || outcome.entityId}</td>
                <td className={`text-${variantFor(outcome.status)}`}>{outcome.status}</td>
                <td>{outcome.reason}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}

      {/* Undo does not survive a page reload: there is no decisions table, so the
          only record of what this batch changed is the report held in memory. */}
      {!report.dryRun && onRevert && report.applied > 0 && (
        <Button variant="outline-secondary" size="sm" onClick={onRevert}>
          Revert this batch ({report.applied})
        </Button>
      )}
    </Alert>
  )
}
